import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplierControlComponent } from './supplier-control/supplier-control.component';
import { OtherRoutingModule } from './other-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';

import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { WidgetModule } from 'src/app/shared/widget/widget.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FilesComponent } from './files/files.component';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { KeepAliveFilesComponent } from './keep-alive-files/keep-alive-files.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterSerial'
})
export class FilterSerialPipe implements PipeTransform {
  transform(lista: any[], termo: string): any[] {
    if (!lista) return [];
    if (!termo) return lista;
    termo = termo.toLowerCase();
    return lista.filter(item =>
      item.serial?.toLowerCase().includes(termo)
    );
  }
}
@NgModule({
  declarations: [
    SupplierControlComponent,
    DashboardComponent,
    FilesComponent,
    KeepAliveFilesComponent,
    FilterSerialPipe,
  ],
  imports: [
    CommonModule,
    OtherRoutingModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    NgSelectModule,
    WidgetModule,
    DropzoneModule,
    MatProgressBarModule,
    MatIconModule,
    NgbTooltipModule,
    NgSelectModule,
    NgbNavModule,
    NgxJsonViewerModule,
    SharedModule,
    NgxPaginationModule,
    UiSwitchModule.forRoot({
      size: 'small',
    }),
  ],
})
export class OtherModule {}
